import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href: string;
  external?: boolean;
  className?: string;
}
export function CTAButton({
  children,
  href,
  external = false,
  className = ''
}: CTAButtonProps) {
  return <a href={href} {...external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {}} className={`block w-full rounded-lg border-b-4 border-[#A8410A] bg-burnt px-4 py-3.5 text-center text-base font-extrabold uppercase leading-tight tracking-tight text-white transition-[transform,background-color] duration-150 ease-out hover:bg-[#E56A1E] active:translate-y-[2px] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/60 sm:text-lg ${className}`} data-id="element-39" data-mp="2kzfy99hw0mer">
      {children}
    </a>;
}